import { render, staticRenderFns } from "./cancelbooking.vue?vue&type=template&id=8d8d4870"
import script from "./cancelbooking.vue?vue&type=script&lang=js"
export * from "./cancelbooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports